export default {"src":"/_next/static/media/sales.0741ef8e.svg","height":28,"width":27};